export default {"src":"/_next/static/media/errorIcon.b8229cc6.svg","height":89,"width":89};